<template>
  <el-dialog title="人员选择"
             :visible.sync="linkDialog"
             v-dialogDrag
             width="1020px"
             class="choose-box">
    <ioc-table ref="crud"
               :data="personData"
               :option="personOptions"
               :page="personPage"
               @size-change="personChangeSize"
               @current-change="currentChange"
               @search-change="searchList"
               @search-reset="personReset"
               @selection-change="personSelection">
      <!-- 搜索框 自定义 -->
      <template slot="search_departmentName">
        <div style="flex:1;position:relative">
          <el-input placeholder="请选择"
                    style="width:300px;"
                    @click.stop.native="departemntTreeShow"
                    class="bukongObject"
                    clearable
                    @clear="clearDepartment"
                    v-model="queryForm.departmentName"></el-input>
          <div v-if="departmentTree"
               class="tree-container">
            <div style="position:relative;height:100%;overflow-y:auto;">
              <el-tree :props="treeProps"
                       :data="departmentData"
                       :show-checkbox="multiCheck"
                       render-after-expand
                       node-key="areaDevGroupCode"
                       ref="grouptree"
                       @check="setNode">
              </el-tree>
            </div>
            <div style="text-align: center">
              <el-button type="primary"
                         @click="confirmTree">确认</el-button>
              <el-button type="info"
                         @click="cancelTree">取消</el-button>
            </div>
          </div>
        </div>
      </template>
    </ioc-table>
    <el-form :model="authorityForm"
             ref="form"
             label-width="110px"
             :rules="rules">
      <el-row>
        <el-col :span="8">
          <el-form-item label="通行生效时间"
                        prop="effectiveTime">
            <el-date-picker v-model="authorityForm.effectiveTime"
                            type="datetime"
                            placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="通行失效时间"
                        prop="expirationTime">
            <el-date-picker v-model="authorityForm.expirationTime"
                            type="datetime"
                            placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人脸道闸"
                        prop="carGate">
            <el-select v-model="authorityForm.carGate"
                       multiple
                       collapse-tags
                       placeholder="请选择">
              <el-option v-for="item in treeData"
                         :key="item.thirdDeviceId"
                         :label="item.thirdDeviceName"
                         :value="item.thirdDeviceId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="cancleChoose">取消</el-button>
      <el-button type="primary"
                 @click="confirmChoose">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import { Dic, Bus, Dates } from "$utils";
import utils from '@src/common/utils'
import i18n from "@src/common/lib/i18n";
import personOptions from "../config/personOptions";
import { formatTimeToStr } from "../filter/dateUtils"
export default {
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
    departmentData: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      personOptions: personOptions(),
      linkDialog: false,
      personData: [],
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      personSearch: {},
      // 授权表单数据
      authorityForm: {
        effectiveTime: Dates.parse(Dates.format(new Date())),
        expirationTime: "2037-12-31 00:00:00",
        carGate: []
      },
      rules: {
        effectiveTime: [
          {
            required: true,
            message: "请选择通行生效时间",
            trigger: "blur",
          },
        ],
        expirationTime: [
          {
            required: true,
            message: "请选择通行失效时间",
            trigger: "blur",
          },
        ],
        carGate: [
          {
            required: true,
            message: "请选择人脸道闸",
            trigger: "change",
          },
        ],
      },
      // 车辆选择弹框选择的车辆ID
      personIds: [],
      queryForm: {
        departmentName: '',
        departmentCodeList: []
      },
      departmentTree: false,
      // 部门树的props
      treeProps: {
        children: "children",
        label: "label",
        isLeaf: "isLeaf",
      },
      multiCheck: true,
    }
  },
  watch: {
  },
  mounted () {
    this.getPersonList();
  },
  methods: {
    open (id) {
      this.linkDialog = true;
    },
    departemntTreeShow () {
      this.departmentTree = true
    },
    confirmTree () {
      this.departmentTree = false
    },
    cancelTree () {
      this.departmentTree = false
    },
    setNode (data, list) {
      // console.log('--数据----', data);
      // console.log('===列表==departmentName=', list);
      let checkedCodes = []
      checkedCodes = list.checkedNodes;
      this.queryForm.departmentName = ''
      this.queryForm.departmentCodeList = [];
      const areaName = []
      checkedCodes.map((val) => {
        areaName.push(val.label)
        this.queryForm.departmentCodeList.push(val.value)
      })
      this.queryForm.departmentName = areaName.toString();
    },
    clearDepartment () {
      this.queryForm.departmentCodeList = [];
      this.queryForm.departmentName = '';
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    // 获取人员选择弹框中人员列表
    getPersonList () {
      const params = {};
      params.personnelType = 1;
      params.workNo = this.personSearch.workNo;
      params.name = this.personSearch.name;
      params.beginTime = this.personSearch.modifyTime ? formatTimeToStr(this.personSearch.modifyTime[0]) : "";
      params.endTime = this.personSearch.modifyTime ? formatTimeToStr(this.personSearch.modifyTime[1]) : "";
      params.departmentCodeList = this.queryForm.departmentCodeList;
      params.pageNum = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      this.$fetch(api.person.getPersonList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    // 人员选择确认弹框
    confirmChoose (flag) {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          if (
            this.authorityForm.effectiveTime > this.authorityForm.expirationTime
          ) {
            this.$message({
              type: "warning",
              duration: 2000,
              message: "通行失效时间不可早于通行生效时间",
            });
            return;
          }
          if (this.personIds.length === 0) {
            this.$message({
              type: "warning",
              duration: 2000,
              message: "请选择人员",
            });
            return;
          }
          let params = {
            thirdDeviceIdList: this.authorityForm.carGate, //闸机的第三方设备ID组
            personnelCodeList: this.personIds,
            effectiveTime: this.authorityForm.effectiveTime
              ? Dates.dayjs(this.authorityForm.effectiveTime).format(
                "YYYY-MM-DD HH:mm:ss"
              )
              : "",
            expirationTime: this.authorityForm.expirationTime
              ? Dates.dayjs(this.authorityForm.expirationTime).format(
                "YYYY-MM-DD HH:mm:ss"
              )
              : "",
          };
          if (flag) {
            params.updateFlag = flag
          }
          // 调用新增授权的接口
          this.$fetch(api.person.addAuthority, params).then((response) => {
            if (!response.success) {
              if (response.msgCode === '103008602010004') {
                // 如果相同的停车场存在授权信息（未失效记录），则提示已经存在XXX人脸的授权信息（有一个提示一个，有多个提示多个），请是否确定覆盖授权
                // this.$message.success(response.msgContent);
                this.againConfirm(response.msgContent);
              } else {
                this.$message.error(response.msgContent);
                return;
              }
            } else {
              this.$message.success(response.msgContent);
              this.$emit("refreshList")
              this.authorityForm.carGate = [];
              this.linkDialog = false;
            }
          });
        }
      });
    },
    againConfirm (message) {
      this.$confirm(message, "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.confirmChoose(1);
      });
    },
    // 人员选择取消弹框
    cancleChoose () {
      this.authorityForm.carGate = []
      this.linkDialog = false;
    },
    personSelection (items) {
      this.personIds = items.map((item) => {
        return item.personnelCode;
      });
    },
    // 员工弹框修改每页数据数量
    personChangeSize (val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange (val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList (param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset () {
      this.queryForm.departmentName = '';
      this.queryForm.departmentCodeList = [];
      this.getPersonList();
    },

  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-box {
  .el-dialog__body {
    .ioc-table {
      height: 500px;
      .ioc-table__search {
        .el-range-editor {
          width: 360px;
        }
        .tree-container {
          @include set_theme_color(background-color, item-active-bg-color);
          position: absolute;
          bottom: -255px;
          width: 100%;
          z-index: 999999;
          height: 250px;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
}
</style>
